import {Component, OnInit, OnChanges, ElementRef, Output, EventEmitter, Input, ViewChild} from '@angular/core';
import * as sanitizeHtml from 'sanitize-html';

import { CDSNode, Rule,  Package} from '../services/capd.model';
import { PackageService } from '../services/package.service';
import { OrgService } from '../services/org.service';
import { RulesService } from '../services/rules.service';
import { ExportToCsv } from "export-to-csv";
import { ActivatedRoute } from "@angular/router";
import {CDSTreeComponent} from "../cds_tree/cds-tree.component";
import {CompanyFdMessageEditorComponent} from "./company-fd-message-editor.component";
import {TenantMappingsComponent} from "../cds_tenant_mapping/tenant_mappings_org.component";
import * as _ from 'underscore';
import {AlertService} from "../services/alert.service";

declare var $: any;
@Component({
  selector: 'company-detail',
  templateUrl: './company-detail.component.html',
  inputs: ['org', 'pack', 'csvData'],
  providers: [CDSTreeComponent, TenantMappingsComponent]
})

/**
 * The detailed list of rules for a given company/organization.  Has several interactions that need to be updated.
 */
export class CompanyDetailComponent implements OnInit, OnChanges {
  @ViewChild(CompanyFdMessageEditorComponent) fdMessageCompRef: CompanyFdMessageEditorComponent;
  @ViewChild('warningRulesNotAdded', null) warningRulesNotAdded: ElementRef;

  @Output() update: EventEmitter<any> = new EventEmitter();
  @Output() selectedPack: EventEmitter<any> = new EventEmitter();
  scope: string;
  @Input() org: CDSNode;
  @Input() pack: Package;

  packRules: any;
  toAdd: Rule[] = [];
  selectedRule: Rule;
  rootRule: Rule;
  watermarkText: any;
  selectRulesEnabled = false;
  isUpdating = false;
  infoOnly = false;
  tenant = "";
  haveRulesBeenFiltered = false;

  addedRules : any = [];
  rulesNotAdded: any = [];
  csvDataRulesNotAdded: any = [];

  // Variables for Add modal
  root: string;
  groupList: CDSNode[];
  groupToAdd: CDSNode[] = [];
  hasGroups = 'loading';
  alerts: any[];
  dismissible = true;

  // Variables for Rule modal
  userScope: string;
  rule: any;
  env: number[] = [];
  customRule: Rule = null;
  oldRule: Rule = null;
  private sub: any;

  // Variables for Delete modal
  isDisabled = true;
  @Input() csvData: any;
  canEditOrg: boolean = true;

  // Variables for the Sync modal
  isSyncDisabled = true;

  constructor(private _service: PackageService,
              private _el: ElementRef,
              private _orgService: OrgService,
              private _rulesService: RulesService,
              private _route: ActivatedRoute,
              private _cdsComponent: CDSTreeComponent,
              private _tenantMappingsComponent: TenantMappingsComponent,
              private alertService: AlertService) { }

  /**
   * Finds the current scope of the user and manages what changes they can make.
   *
   * @func ngOnInit
   */
  ngOnInit() {
    let previousPackOrgId = sessionStorage.getItem('packorgid');
    if (previousPackOrgId && previousPackOrgId != this.pack.id + this.org.rootId + this.org.extensionId) {
      this.alerts = [];
      sessionStorage.removeItem('alerts');
    }
    sessionStorage.setItem('packorgid', this.pack.id + this.org.rootId + this.org.extensionId);
    this.alerts = JSON.parse(sessionStorage.getItem('alerts'));
    this.scope = sessionStorage.getItem('scope');

    if (!!this.org.rootId) {
      this._orgService.getGroups(this.org).then((groups :CDSNode[]) =>
          this.groupList = groups.sort(function(a, b) {
            const asplit = a.description.split(/\s?\/\s?/);
            const bsplit = b.description.split(/\s?\/\s?/);
            if (asplit.length - bsplit.length === 0) {
              let compareReturn = asplit[0].localeCompare(bsplit[0]);
              let i = 1;
              while (compareReturn === 0 && i < asplit.length) {
                compareReturn = asplit[i].localeCompare(bsplit[i]);
                i++;
              }
              return compareReturn;
            }
            else if (asplit.length < bsplit.length) {
              return -1;
            }
            else {
              return 1;
            }
          })
      ).then(() => {
        if(this.groupList && this.groupList.length > 0) {
          this.hasGroups = 'true';
        } else {
          this.hasGroups = 'false';
        }
      });
      this.root = this.org.rootId;

    }
    this.doUpdate();
  }
  /**
   * Filters the rules to be displayed based on whether they have customer tenant(s) set and if that matches the mapped tenant for the org
   *
   * @func filterRulesByTenant
   */
  filterRulesByTenant() {
    this._tenantMappingsComponent.expandedRoot = this.org.rootId.replace('~', '2.16.840.1.113883.3.21');
    this._tenantMappingsComponent.loadMapping().then(result => {
      if(this._tenantMappingsComponent.thisMapping && this._tenantMappingsComponent.thisMapping.tenant) {
        this.tenant = this._tenantMappingsComponent.thisMapping.tenant;
        this._service.tenant = this.tenant;
      }

      this.addedRules = this.addedRules.filter(rule => {
        return this._service.shouldRuleDisplayBasedOnTenant(rule, this.tenant);
      });
      this.packRules.oldRules = this.packRules.oldRules.filter(rule => {
        return this._service.shouldRuleDisplayBasedOnTenant(rule, this.tenant);
      });

      this.haveRulesBeenFiltered = true;
    });

  }

  /**
   * Calls the update function whenever changes are made.
   *
   * @func ngOnChanges
   */
  ngOnChanges() {
    //@ts-ignore
    let selectAllRulesCheckbox = document.getElementById("selectAllRules") as HTMLInputElement;
    if (selectAllRulesCheckbox) {
      selectAllRulesCheckbox.checked = false;
    }
    this.addedRules = []
    this.doUpdate();
    this.userScope = sessionStorage.getItem('scope');
  }

  /**
   * Toggle checkbox that disables the sync button by default.
   *
   * @func toggleSyncDisabled
   */
  toggleSyncDisabled() {
    this.isSyncDisabled = !this.isSyncDisabled
  }

  /**
   * Syncs the Description, Message Title, and Fluency Direct Message
   * of the nude/rule to the defaults in the M*Modal library.
   *
   * @async
   * @func onSync
   */
  onSync() {
      if(this.rootRule) {
        this.selectedRule.triggerName = this.rootRule.triggerName;
        this.selectedRule.action.messageTitle = this.rootRule.action.messageTitle;
        this.selectedRule.action.messageText = this.rootRule.action.messageText;
        if (this.fdMessageCompRef) {
          this.fdMessageCompRef.setEditorText();
        }
        this.isSyncDisabled = true;
        if (this.selectedRule.delayHours == 0) {
          this.selectedRule.modified = false;
        }
        if (this.rootRule.delayHours == 0) {
          this.rootRule.modified = false;
        }
        $(this._el.nativeElement).find('#chkbx_sync').checked = false;
        this.hideSyncModal();
        this.alertService.showAlert("Rule successfully synced to M*Modal Library");
      } else {
        this.alertService.showAlert("There was an error syncing this rule");
      }
  }

matchesLibrary() {
    let selectedTriggerName = '';
    let selectedMessageTitle = '';
    let selectedMessageText = '';
    if (this.selectedRule && this.selectedRule.triggerName) {
      selectedTriggerName = this.selectedRule.triggerName;
    }
    if (this.selectedRule && this.selectedRule.action && this.selectedRule.action.messageTitle) {
      selectedMessageTitle = this.selectedRule.action.messageTitle
    }
    if (this.selectedRule && this.selectedRule.action && this.selectedRule.action.messageText) {
      selectedMessageTitle = this.selectedRule.action.messageText
    }

    let rootTriggerName = '';
    let rootMessageTitle = '';
    let rootMessageText = '';
    if (this.rootRule && this.rootRule.triggerName) {
      rootTriggerName = this.rootRule.triggerName;
    }
    if (this.rootRule && this.rootRule.action && this.rootRule.action.messageTitle) {
      rootMessageTitle = this.rootRule.action.messageTitle
    }
    if (this.rootRule && this.rootRule.action && this.rootRule.action.messageText) {
      rootMessageTitle = this.rootRule.action.messageText
    }

    return selectedTriggerName === rootTriggerName
      && selectedMessageTitle === rootMessageTitle
      && selectedMessageText === rootMessageText;
}

  /**
   * Toggle checkbox that disables the delete button by default.
   *
   * @func toggleDisabled
   */
  toggleDisabled() {
    this.isDisabled = !this.isDisabled;
  }

  /**
   * Removes the package assignment from the company/org.
   *
   * @async
   * @func onDelete
   */
  async onDelete() {
    await this._orgService.removePackageFromOrg(this.pack.id, this.org.rootId).then(() => {this.update.emit(null); });
    this.update.emit(null);
    this.hideDeleteModal();
  }

  /**
   * Passes updates made here to the parent component, to update the package list.
   */
  passUpdate() {
    this.update.emit(null);
  }

  /**
   * Called whenever the list of rules is updated or changed.
   * Gets all current rules and the groups they are assigned to.
   *
   * @func doUpdate
   */
  doUpdate() {
    this.updateCanEdit();
    this.haveRulesBeenFiltered = false;
    this.toAdd = new Array<Rule>(0);
    this.watermarkText = '<span>Loading...<br /><br /><img src="./app/css/img/linear-loader.gif" alt=""/></span>';
    if (this.pack || this.pack === null) {
      if (this.pack.packageRules)
        this.packRules = {
          oldRules: this.pack.packageRules.sort((a, b) => a.triggerName.localeCompare(b.triggerName))
        };
      else
        this.packRules = {}

      if (this.pack.newRules)
        this.addedRules = this.pack.newRules
    }
    this.filterRulesByTenant();
  }

  /**
   * Unsure of what this function does and I'm working on like 3 hours of sleep.
   */
  filterNewRules(rule: Rule): boolean {
    //when we update a rule's group assignment, we need to make sure the new rules get updated as well
    let match = this.addedRules.find(added => added.rule_id == rule.rule_id)
    let index = this.addedRules.indexOf(match)
    if(index >= 0) {
      //@ts-ignore
      this.addedRules[index].groupNames = rule.groupNames
    }

    // return only rules that are NOT newly added
    return !this.addedRules.find(array => array.rule_id === rule.rule_id);
  }

  /**
   * Prints a list of all groups a rule is assigned to.
   *
   * @func printUserGroups
   * @returns a string of all non-null groupNames, separated by commas.
   * @param rule
   */
  printGroupNames(rule) {
    let groupString = '';
    const noNull: string[] = rule.groupNames.filter(group => !!group);
    for (let i = 0; i < noNull.length - 1; i++) {
      groupString += noNull[i] + ', ';
    }
    if (noNull.length > 0) {
      groupString += noNull[noNull.length - 1];
    }

    return groupString;

  }

  /**
   * Checks or unchecks a rule to edit.
   *
   * @func onSelect
   * @param {Rule} rule - the rule to check/uncheck.
   */
  onSelect(rule) {
    if(this.canEditOrg) {
      this.env = [];

      // if the script value is not yet present, set a default
      if (rule.action.actionSubtype == "Static" && rule.action.actionType == "Script" && rule.action.groups.length == 0) {
        rule.action.groups = [{messageText: "", type: "Text", options: []}]
      }

      if (!!this.org.rootId) {
        this._orgService.getGroups(this.org).then((groups: CDSNode[]) =>
            this.groupList = groups.sort(function(a, b) {
              const asplit = a.description.split(/\s?\/\s?/);
              const bsplit = b.description.split(/\s?\/\s?/);
              if (asplit.length - bsplit.length === 0) {
                let compareReturn = asplit[0].localeCompare(bsplit[0]);
                let i = 1;
                while (compareReturn === 0 && i < asplit.length) {
                  compareReturn = asplit[i].localeCompare(bsplit[i]);
                  i++;
                }
                return compareReturn;
              } else if (asplit.length < bsplit.length) {
                return -1;
              } else {
                return 1;
              }
            })
        ).then(() => {
          if (this.groupList && this.groupList.length > 0) {
            this.hasGroups = 'true';
          } else {
            this.hasGroups = 'false';
          }
        });
        this.root = this.org.rootId;
      }

      if (this.selectRulesEnabled) {
        const index = this.toAdd.indexOf(rule);
        if (index < 0) {
          this.toAdd.push(rule);
        } else {
          this.toAdd.splice(index, 1);
        }
      } else {
        this.selectedRule = rule;
        this._rulesService.getRules().then((rules: Rule[]) => {
          this.rootRule = rules.find(i => i.triggerCode === this.selectedRule.triggerCode);
        });
        $(this._el.nativeElement).find('#modal-rule-details').show();
        if (this.fdMessageCompRef) {
          this.fdMessageCompRef.setEditorText();
        }
      }

      this.sub = this._route.params.subscribe(params => {
        if (this.selectedRule) {
          setTimeout(() => {
            this.customRule = this.selectedRule;
            this.oldRule = JSON.parse(JSON.stringify(this.selectedRule));
            this.root = params.id;
            if (this.customRule.action.messageText) {
              this.env.push(0);
            }
            if (this.customRule.action.groups[0] && this.customRule.action.groups[0].messageText != "") {
              this.env.push(1);
            }
            if (!this.customRule.action.messageText && !this.customRule.action.groups) {
              this.env = [];
            }
          }, 1);
        }
      });
    }
  }

  /**
   * Uses the checkbox on the header to select/deselect all rules automatically.
   *
   * @func onHeaderSelect
   */
  onHeaderSelect() {
    if (!!this.org.rootId) {
      this._orgService.getGroups(this.org).then((groups :CDSNode[]) =>
          this.groupList = groups.sort(function(a, b) {
            const asplit = a.description.split(/\s?\/\s?/);
            const bsplit = b.description.split(/\s?\/\s?/);
            if (asplit.length - bsplit.length === 0) {
              let compareReturn = asplit[0].localeCompare(bsplit[0]);
              let i = 1;
              while (compareReturn === 0 && i < asplit.length) {
                compareReturn = asplit[i].localeCompare(bsplit[i]);
                i++;
              }
              return compareReturn;
            }
            else if (asplit.length < bsplit.length) {
              return -1;
            }
            else {
              return 1;
            }
          })
      ).then(() => {
        if(this.groupList && this.groupList.length > 0) {
          this.hasGroups = 'true';
        } else {
          this.hasGroups = 'false';
        }
      });
      this.root = this.org.rootId;
    }

    if (this.toAdd.length >= this.packRules.oldRules.length || this.toAdd.length >= this.packRules.oldRules.length + this.addedRules.length) {
      this.toAdd = [];
    }
    else {
      this.packRules.oldRules.forEach(rule => this.addAll(rule));
    }
  }

  /**
   * Adds all rules not currently selected, one by one.
   *
   * @func addAll
   * @param {Rule} rule - the current rule being added.
   */
  addAll(rule) {
    const index = this.toAdd.indexOf(rule);
    if (index < 0) {
      this.toAdd.push(rule);
    }
  }

  /**
   * Displays the info for the selected rule.
   *
   * @async
   * @func onInfo
   * @param {Rule} rule - the rule to display info for.
   */
  onInfo(rule) {
    this.selectedRule = rule;
    this.infoOnly = true;
    $(this._el.nativeElement).find('#modal-rule-details').show();
    if(this.fdMessageCompRef) {
      this.fdMessageCompRef.setEditorText();
    }
  }

  /**
   * Adds or removes a selected option to the list of groups to add rules to.
   *
   * @func updateChecked
   * @param {any} option - the option to add or remove.
   */
  updateChecked(option) {
    // Check to see if the option is in the array
    const index = this.groupToAdd.indexOf(option);
    // If it's not, add it to the end
    if (index < 0) {
      this.groupToAdd.push(option);
    }
    // Otherwise, remove it
    else {
      this.groupToAdd.splice(index, 1);
    }
  }

  /**
   * Confirms the list of groups and assigns the selected rules to the selected groups.
   *
   * @async
   * @func onSubmit
   */
  async onSubmit() {
    let matchedRulesGroups = []
    let identifiedGroupOids = []

    // get all rules assigned to the selected groups
    // check to see if there are any matching trigger codes between the currently assigned rules and the rules to be assigned
    await this._orgService.getRulesForGroups(this.root, this.groupToAdd).then((rules: Rule[]) => {
      // check for missing triggerCode and triggerName and add those derived from rule_id
      rules.forEach(rule => {
        if (!rule.triggerCode) {
         rule.triggerCode = rule.rule_id;
          if (rule.triggerCode.indexOf('_') > 0) {
            rule.triggerCode = rule.triggerCode.split('_')[0];
          }
        }
        if (!rule.triggerName) {
          let packRule = this.packRules.oldRules.find(r => {
            return r.triggerCode === rule.triggerCode;
          });
          if (packRule && packRule.triggerName) {
            rule.triggerName = packRule.triggerName;
          }
        }
      });
      let matchedRules = rules.filter(rule => this.toAdd.some(x => x.triggerCode == rule.triggerCode))
      matchedRulesGroups = _.groupBy(matchedRules, "group_id")
      identifiedGroupOids = [... new Set(rules.map(rule => rule.group_id))]
    })

    // if all of the rules will be new to the groups, proceed as normal
    // else, identify what we need to skip
    if(Object.keys(matchedRulesGroups).length == 0) {
      this.assignRulesToGroups(this.toAdd, this.groupToAdd, this.root);
      this.update.emit(null);
    } else {
      // identify any groups we can add a to
      let groupsToAddAll = this.groupToAdd.filter(grp => !identifiedGroupOids.includes(grp.rootId + "/" + grp.extensionId) )
      if(groupsToAddAll != undefined && groupsToAddAll.length != 0)
        this.assignRulesToGroups(this.toAdd, groupsToAddAll, this.root)

      // for each oid, identify the rules that we can assign and then assign only those rules
      identifiedGroupOids.forEach(oid => {
        let rulesToAdd = [];
        if (matchedRulesGroups[oid] && matchedRulesGroups[oid].length > 0) {
          rulesToAdd = this.toAdd.filter(r => !matchedRulesGroups[oid].some(x => r.triggerCode == x.triggerCode));
          matchedRulesGroups[oid].filter(r => this.toAdd.some(x => r.triggerCode == x.triggerCode)).forEach(r => {
            this.rulesNotAdded.push(r);
          });
        }
        let groupNode = this.groupToAdd.filter(grp => grp.rootId + "/" + grp.extensionId == oid);
        if (rulesToAdd.length > 0)
          this.assignRulesToGroups(rulesToAdd, groupNode, this.root);
      })

      if(this.rulesNotAdded.length != 0){
        this.warningRulesNotAdded.nativeElement.classList.toggle("show");
      }
    }

  }


  async assignRulesToGroups(rulesToAdd, groups, root) {
    this.alerts = [];
    sessionStorage.removeItem('alerts');
    // needed to correctly add rule with a "rule_id"
    rulesToAdd.forEach(rule => {
      if (rule.rule_id == "undefined" || rule.rule_id == null ) {
        if(rule.ruleId != "undefined" && rule.ruleId != null)
          //@ts-ignore
          rule.rule_id = rule.ruleId;
        else {
          // if rule_id and ruleId dont exist, do not add the rule to the group
          var index = rulesToAdd.indexOf(rule)
          rulesToAdd.splice(index, 1)
          console.log("Rule " + rule.triggerCode + " was not added to group because ruleId was undefined");
        }
    }
    })

    await this._orgService.assignRulesToGroup(rulesToAdd, groups, root).then(() => {
      this.hideOrgAssignModal();
      let successAddedToGroupMessage = "Content successfully added to ";
      if(groups.length === 1) {
        successAddedToGroupMessage += groups[0].description;
      } else {
        successAddedToGroupMessage += groups.length + " groups";
      }
      let successAddedToGroupAlert = {type: "success", msg: successAddedToGroupMessage};
      this.alerts.push(successAddedToGroupAlert);
      sessionStorage.setItem('alerts', JSON.stringify(this.alerts));
      groups = new Array(0); rulesToAdd = new Array(0);
    }).then(() => this.doUpdate());

  }
  onClosed(dismissedAlert: any): void {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
    sessionStorage.removeItem('alerts');
    if (this.alerts.length > 0) {
      sessionStorage.setItem('alerts', JSON.stringify(this.alerts));
    }
  }

  /**
   * When the user cancels the action, clear the list of selected groups.
   *
   * @func onCancel
   */
  onCancel() {
    this.groupToAdd = new Array(0);
    // reset ALL rule values so if a user click the same rule,
    // they do not see unsaved values
    this.rule = JSON.parse(JSON.stringify(this.oldRule));
    this.selectedRule = JSON.parse(JSON.stringify(this.oldRule))
    this.customRule = JSON.parse(JSON.stringify(this.oldRule))
    let foundIndex = this.packRules.oldRules.findIndex(x => x.triggerCode == this.oldRule.triggerCode)
    this.packRules.oldRules[foundIndex] = this.oldRule

    $('input[type=checkbox]').prop('checked', false);
    try {
      // reset the rule value in the fd message editor as well
      this.fdMessageCompRef.resetRule(this.oldRule);
    } catch(e) {
      console.log('Something went wrong while reseting rule view!')
    }
  }

  /**
   * Checks to see if a rule has been changed from its original state.
   *
   * @func isUnchanged
   * @returns true if the rule has NOT been changed; false otherwise.
   */
  isUnchanged() {
    if (this.oldRule && this.selectedRule) {
      // create temp values to compare
      // replace any values that may have been sanitized or encoded by the third party text box in use
      let temp1 = this.replaceRuleTextForCompare(this.oldRule);
      let temp2 = this.replaceRuleTextForCompare(this.selectedRule);
      return (JSON.stringify(temp1) == JSON.stringify(temp2));
    } else {
      return true;
    }
  }

  /**
   * Replaces encoded values and tags added by the third party text box used in the rule edit modal
   * We do this so that the value matches the initial input, and can be compared
   * @param rule
   */
  replaceRuleTextForCompare(rule) {
    let ruleJson = JSON.stringify(rule).replaceAll('&nbsp;', ' ').replaceAll('<br>', '')
        .replaceAll('&lt;', '<').replaceAll('&gt;', '>').replaceAll('<p>', '')
        .replaceAll('/r', '').replaceAll('/n', '')
        .replaceAll(' rel=\\"nofollow noopener noreferrer\\"', '')
        .replaceAll(' rel=\\"noopener noreferrer\\"', '')
        .replaceAll('</p>', '');
    let newRule = JSON.parse(ruleJson);
    if (newRule.action.messageText) {
      newRule.action.messageText = newRule.action.messageText.trim();
    } else if (this.customRule.action.groups[0].messageText) {
      newRule.action.groups[0].messageText = newRule.action.groups[0].messageText.trim();
    }
    return newRule;
  }

  /**
   * At a user's request, this creates a downloadable .csv
   * file with the aforementioned data.
   *
   * @func exportCsv
   */
  exportCsv() {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Company Package Export CSV',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true
    };

    const csvExporter = new ExportToCsv(options);

    if(!(this.csvData === undefined) && this.csvData !== null) {
      csvExporter.generateCsv(this.csvData);
    } else {
      this.alertService.showAlert("Invalid Export. No data provided.");
    }
  }

  clearSelections() {
    this.toAdd = new Array(0);
    this.groupToAdd = new Array(0);
  }

  selectAll() {
    this.packRules.oldRules.forEach(rule => this.addAll(rule));
    this.packRules.newRules.forEach(rule => this.addAll(rule));
  }

  checkSelected() {
    if($('input[type=checkbox]:not(:checked)')) {
      $('#selectAllRules').prop('checked', false);
    }
  }

  cancelSelection() {
    this.selectRulesEnabled = false;
    this.clearSelections();
  }

  hideOrgAssignModal() {
    $(this._el.nativeElement).find('#modal-org-assign-package').hide();
  }

  showOrgAssignModal() {
    $(this._el.nativeElement).find('#modal-org-assign-package').show();
  }

  hideRuleDetails() {
    this.infoOnly = false;
    $(this._el.nativeElement).find('#modal-rule-details').hide();
  }

  showRuleDetailsModal() {
    $(this._el.nativeElement).find('#modal-rule-details').show();
  }

  hideDeleteModal() {
    $(this._el.nativeElement).find('#modal-delete-pack').hide();
    this.selectedPack.emit(null);
  }

  showDeleteModal() {
    $(this._el.nativeElement).find('#modal-delete-pack').show();
  }

  showSyncModal() {
    $(this._el.nativeElement).find('#modal-sync-pack').show();
  }

  hideSyncModal() {
    $(this._el.nativeElement).find('#modal-sync-pack').hide();
  }

  /**
   * Saves a customized version of the rule.
   *
   * @async
   * @func onSubmit
   */
  saveChanges() {
    //@ts-ignore
    this.customRule.rule_id = this.customRule.ruleId
    if(!this.customRule.rule_id) {
      this.customRule.rule_id = this.customRule._id.replace(this.customRule.contentPackage_id + "_", "");
    }
    // Sanitize input to avoid XSS attacks from the client
    this.customRule.action.messageTitle = this.encodeHTML(this.customRule.action.messageTitle);
    this.customRule.action.messageText = this.sanitizeHtml(this.customRule.action.messageText);
    if(this.matchesLibrary()) {
      this.customRule.modified = false;
      this.selectedRule.modified = false;
    } else {
      this.customRule.modified = true;
      this.selectedRule.modified = true;
    }
    this._rulesService.saveCustomRule(this.customRule, this.root).then(() => {
      this.update.emit(null);
      $(this._el.nativeElement).find('#modal-rule-details').hide();
    });
  }

  // Replace & " < > '
  encodeHTML(inputText) {
    if(inputText) {
      return inputText.replace(/&/g, '&amp;')
          .replace(/"/i, '&quot;')
          .replace(/</i, '&lt;')
          .replace(/>/i, '&gt;')
          .replace(/'/i, '&apos;');
    }
    return '';
  }

  encodeImage(inputText) {
    return inputText.replace(/<img/i, '&lt;img')
        .replace(/<\/img>/i, '&lt;img&gt;');
  }

  encodeAlert(inputText) {
    return inputText.replace(/alert\(/i, ' ');
  }

  // Decode bold, italic, and underline tags currently used to style some cards
  decodeBoldItalicUnderline(inputText) {
    return inputText.replace(/&lt;b&gt;/i, '<b>')
        .replace(/&lt;\/b&gt;/i, '</b>')
        .replace(/&lt;i&gt;/i,'<i>')
        .replace(/&lt;\/i&gt;/i,'</i>')
        .replace(/&lt;u&gt;/i,'<u>')
        .replace(/&lt;\/u&gt;/i,'</u>')
        .replace(/&lt;li&gt;/i,'<li>')
        .replace(/&lt;\/li&gt;/i,'</li>')
        .replace(/&lt;ul&gt;/i,'<ul>')
        .replace(/&lt;\/ul&gt;/i,'</ul>')
        .replace(/&lt;ol&gt;/i,'<ol>')
        .replace(/&lt;\/ol&gt;/i,'</ol>');
  }

  decodeLinks(inputText) {
    return inputText.replace(/&lt;a/, '<a');
  }

  sanitizeHtml(inputText) {
    return sanitizeHtml(inputText,  {
      allowedTags: [ 'b', 'i', 'em', 'strong', 'a', "aside", "footer", "header", "h1", "h2", "h3", "h4",
        "h5", "h6", "div", "caption", "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead",
        "tr", "li", "main", "ol", "p", "pre", "ul", "br", "u"],
      allowedAttributes: {
        'a': [ 'href', 'name', 'target' ]
      },
      disallowedTagsMode: 'discard',
      selfClosing: [ 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta' ],
      allowedSchemes: [ 'http', 'https', 'ftp', 'mailto', 'tel' ],
      allowedSchemesByTag: {},
      allowedSchemesAppliedToAttributes: [ 'href', 'src', 'cite' ],
      allowProtocolRelative: true,
      enforceHtmlBoundary: false
    }).replace(/<\/br>/g, '');
  }

  cancelRuleAssign() {
    $('input[type=checkbox]').prop('checked', false);
    this.clearSelections();
    this.hideOrgAssignModal();
  }

  onHideRulesNotAdded() {
  this.warningRulesNotAdded.nativeElement.classList.toggle("show");
  this.update.emit(null);
  }

  getGroupName(oid) {
    let name = this.groupToAdd.find(g => g.rootId + "/" + g.extensionId == oid).description
    return name
  }

  createRulesNotAddedCsv() {
    this.csvDataRulesNotAdded = [];
    this.rulesNotAdded.forEach(rule => {
      const csvRule = {
        Group: this.getGroupName(rule.group_id),
        TriggerCode: rule.triggerCode,
        RuleName: rule.triggerName
      }
      this.csvDataRulesNotAdded.push(csvRule)
    })
  }

  async exportCsvOfNotAddedRules() {
    await this.createRulesNotAddedCsv();
    const options = {
      filename: this.org.description + '_failed_rule_assignments',
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Rule Group Pairs Not Assigned',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true
    };

    const csvExporter = new ExportToCsv(options);

    if(!(this.csvDataRulesNotAdded  === undefined) && this.csvDataRulesNotAdded  !== null) {
      csvExporter.generateCsv(this.csvDataRulesNotAdded);
    } else {
      this.alertService.showAlert("Invalid Export. No data provided.");
    }
  }

  updateCanEdit() {
    let parentId = '';
    if (this.root) {
      let idEnd = this.root.replace('~', '2.16.840.1.113883.3.21').split('.').pop();
      parentId = this.root.replace('~', '2.16.840.1.113883.3.21').replace('.' + idEnd, '');
    }
    let treeRoots: string[] = sessionStorage.getItem('treeRoots').split(',');
    let companyExtensionCheck = this.org.extensionId.includes('Company');
    let parentIdIncludedInTreeRoots = treeRoots.indexOf(parentId) > -1;

    this.canEditOrg = companyExtensionCheck || parentIdIncludedInTreeRoots;
  }
}
